import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-documents-dialog.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-documents-dialog.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { UserInformationService } from "../../../../shared/services/user/user-information.service";
import { ApplicationCreateService } from "../../application-create.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { SaLongDatePipe } from "../../../../shared/pipes/sa-long-date/sa-long-date.pipe";
import { EditDocumentsDialogConstants } from "./edit-documents-dialog.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { AppConfig } from "../../../../app.config";
import { ApiAttachmentConstants } from "../../../../shared/constants/api-constants/api-attachment.constants";
import { FileUploadService } from "../../../../shared/services/file-upload/file-upload.service";
import { FileUtils } from "src/app/shared/utils/file-utils";
let EditDocumentsDialogComponent = class EditDocumentsDialogComponent {
    activeModal;
    appControllerService;
    userInformationService;
    applicationCreateService;
    requestStatusService;
    fileUploadService;
    saLongDatePipe;
    editDocumentForm;
    documentTypes = [];
    dialogTitle = "";
    documentToEdit;
    configUploadSettings;
    currentApplication;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    documentTypeLabel = EditDocumentsDialogConstants.DOCUMENT_TYPE_LABEL;
    descriptionLabel = EditDocumentsDialogConstants.DESCRIPTION_LABEL;
    fileLabel = EditDocumentsDialogConstants.FILE_LABEL;
    selectFileLabel = EditDocumentsDialogConstants.SELECT_FILE_LABEL;
    cancelBtnLabel = EditDocumentsDialogConstants.CANCEL_BTN_PLACEHOLDER;
    documentTypeFormControlName = EditDocumentsDialogConstants.DOCUMENT_TYPE_FORM_CONTROL;
    descriptionFormControlName = EditDocumentsDialogConstants.DESCRIPTION_FORM_CONTROL;
    saveBtnLabel = EditDocumentsDialogConstants.SAVE_BTN_LABEL;
    uploadedFiles = [];
    documentTypeErrMsg = EditDocumentsDialogConstants.DOCUMENT_TYPE_ERR_MSG;
    descriptionErrMsg = EditDocumentsDialogConstants.DESCRIPTION_ERR_MSG;
    noFileUploadedErrMsg = EditDocumentsDialogConstants.NO_FILE_UPLOADED_ERR_MSG;
    uploadedFileTooBigErrMsg = EditDocumentsDialogConstants.UPLOADED_FILE_TOO_BIG_ERR_MSG;
    filetypeNotAllowedErrMsg = EditDocumentsDialogConstants.UPLOADED_FILE_TYPE_NOT_ALLOWED_ERR_MSG;
    componentName = EditDocumentsDialogConstants.COMPONENT_NAME;
    fileDetails;
    maxFileSize;
    allowedFileTypes = [];
    filteredAllowedFileTypes = [];
    documentUploadedBy;
    fileString;
    fileBlob;
    uploadDocumentObservableSubscription;
    deleteUploadDocumentsObservableSubscription;
    getAttachmentContentSubscription;
    constructor(activeModal, appControllerService, userInformationService, applicationCreateService, requestStatusService, fileUploadService, saLongDatePipe) {
        this.activeModal = activeModal;
        this.appControllerService = appControllerService;
        this.userInformationService = userInformationService;
        this.applicationCreateService = applicationCreateService;
        this.requestStatusService = requestStatusService;
        this.fileUploadService = fileUploadService;
        this.saLongDatePipe = saLongDatePipe;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.initForm();
        this.getAttachmentFileContent(this.documentToEdit.id);
        this.setFormValues();
        this.userInformationService.$authenticatedUser.subscribe((userInfo) => {
            this.documentUploadedBy = `${userInfo.lastName} ${userInfo.firstName}`;
        });
        this.maxFileSize = this.configUploadSettings.maximumSize;
        this.allowedFileTypes = this.configUploadSettings.agsSupportedAttachmentFileTypes.split(",");
        this.filteredAllowedFileTypes = FileUtils.mapAllowedFilesToMimeTypes(this.allowedFileTypes);
    }
    onCancelBtnClicked() {
        this.activeModal.close();
    }
    onSaveBtnClicked() {
        if (this.editDocumentForm.valid && this.uploadedFiles.length > 0) {
            try {
                this.requestStatusService.clearBusyRequestCounter();
                this.requestStatusService.showBusySpinner("save");
                this.uploadAttachment();
            }
            catch (e) {
                this.appControllerService.showMessage(EditDocumentsDialogConstants.UPLOAD_ERROR_MSG, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("save");
            }
        }
        else {
            this.markAllControlsAsTouched();
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    deleteAttachment(i, $event) {
        if (this.uploadedFiles.length > 0) {
            this.uploadedFiles.splice(i, 1);
        }
        $event.stopPropagation();
    }
    onFileSelected(event) {
        this.requestStatusService.clearBusyRequestCounter();
        this.requestStatusService.showBusySpinner("upload");
        try {
            this.fileDetails = null;
            let file;
            if (event.target) {
                file = event.target.files[0];
            }
            else {
                file = event.item(0);
            }
            ;
            if (file) {
                const fileName = file.name;
                const uploadedFileSize = file.size;
                const fileExtension = fileName.split(".").pop();
                if (uploadedFileSize > this.maxFileSize) {
                    this.appControllerService.showMessage(this.uploadedFileTooBigErrMsg, AlertType.Warning);
                    return;
                }
                let fileTypeAllowed = false;
                for (const allowedFileType of this.allowedFileTypes) {
                    if (allowedFileType.trim().toUpperCase() === fileExtension.trim().toUpperCase()) {
                        fileTypeAllowed = true;
                        break;
                    }
                }
                if (fileTypeAllowed) {
                    this.fileDetails = file;
                    this.uploadedFiles[0] = file.name;
                }
                else {
                    this.appControllerService.showMessage(this.filetypeNotAllowedErrMsg, AlertType.Warning);
                }
            }
        }
        catch (e) {
            this.appControllerService.showMessage(EditDocumentsDialogConstants.UPLOAD_ERROR_MSG, AlertType.Warning);
            this.requestStatusService.removeBusySpinner("upload");
        }
        this.requestStatusService.removeBusySpinner("upload");
    }
    uploadAttachment() {
        this.requestStatusService.clearBusyRequestCounter();
        this.requestStatusService.showBusySpinner("upload");
        const formData = new FormData();
        formData.append("appId", this.currentApplication.appId.toString());
        formData.append("jobId", this.currentApplication.jobId.toString());
        formData.append("moduleId", this.appControllerService.selectedModuleID);
        formData.append("fileName", this.fileDetails.name);
        formData.append("description", this.editDocumentForm.get(this.descriptionFormControlName).value);
        formData.append("attachmentType", this.editDocumentForm.get(this.documentTypeFormControlName).value);
        formData.append("componentType", "Upload AFLA portal required documents");
        formData.append("aflaPortalObjectId", "0");
        formData.append("uploadedBy", this.documentUploadedBy);
        formData.append("file", this.fileDetails);
        formData.append("source", "On submission");
        const url = `${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.FUNCTION_UPLOAD_ATTACHMENT_FROM_PORTAL}`;
        this.fileUploadService.uploadFile(url, formData, "portal", "On submission", true, (result) => {
            if (result !== null) {
                this.appControllerService.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
                const attachmentObject = {
                    id: result.id,
                    type: result.attachmentType,
                    name: result.description,
                    dateUploaded: this.saLongDatePipe.transform(result.date),
                    fileName: result.fileName,
                };
                const deletedParams = {
                    ids: [this.documentToEdit.id], moduleId: this.appControllerService.selectedModuleID
                };
                this.deleteUploadDocumentsObservableSubscription = this.applicationCreateService.deleteUploadDocumentsObservable(deletedParams).subscribe({
                    next: () => {
                        const resultObject = {
                            idsToDelete: [this.documentToEdit.id], editedDocument: attachmentObject
                        };
                        this.activeModal.close(resultObject);
                        this.requestStatusService.removeBusySpinner("save");
                        this.requestStatusService.removeBusySpinner("upload");
                    }, error: (error) => {
                        this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Add);
                        this.requestStatusService.removeBusySpinner("save");
                        this.requestStatusService.removeBusySpinner("upload");
                    }
                });
            }
        });
    }
    initForm() {
        this.editDocumentForm = new FormGroup({
            documentType: new FormControl(this.documentToEdit.type, Validators.required),
            description: new FormControl(this.documentToEdit.name, Validators.required),
            fileName: new FormControl(this.documentToEdit.fileName)
        });
    }
    setFormValues() {
        this.editDocumentForm.get(this.documentTypeFormControlName).setValue(this.documentToEdit.type);
        this.editDocumentForm.get(this.descriptionFormControlName).setValue(this.documentToEdit.name);
        this.uploadedFiles[0] = this.documentToEdit.fileName;
    }
    markAllControlsAsTouched() {
        Object.keys(this.editDocumentForm.controls).forEach(key => {
            if (this.editDocumentForm.get(key).invalid) {
                this.editDocumentForm.get(key).markAsTouched();
            }
        });
    }
    getAttachmentFileContent(id) {
        this.getAttachmentContentSubscription = this.applicationCreateService.getAttachmentContent(id).subscribe({
            next: (fileBlob) => {
                this.fileBlob = fileBlob;
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService },
        { type: UserInformationService },
        { type: ApplicationCreateService },
        { type: RequestStatusService },
        { type: FileUploadService },
        { type: SaLongDatePipe }
    ];
    static propDecorators = {
        documentTypes: [{ type: Input }],
        dialogTitle: [{ type: Input }],
        documentToEdit: [{ type: Input }],
        configUploadSettings: [{ type: Input }],
        currentApplication: [{ type: Input }]
    };
};
EditDocumentsDialogComponent = __decorate([
    Component({
        selector: "app-edit-documents-dialog",
        template: __NG_CLI_RESOURCE__0,
        host: { "edit-documents-dialog": "create-application" },
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], EditDocumentsDialogComponent);
export { EditDocumentsDialogComponent };
